import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import swaggerData from '../../../assets/swagger.json';
import './publicApiDocs.scss';
import { RootState } from '../../../store';
import {
  getPublicApiApprovalStatus,
  selector,
} from '../approvePublicApiUserSlice';
import { Status } from '../../../common/constants';
import useNotification from '../../../components/notification/useNotification';
import { env } from '../../../config';
import { useSpinner } from '../../../components/ui/spinner/useSpinner';

const PublicApiDocs = () => {
  const dispatch = useDispatch<RootState>();
  const navigate = useNavigate();
  const { showWarningNotification } = useNotification();
  const { isSuperAdminApproved, status } = useSelector(selector);

  useSpinner(status);

  useEffect(() => {
    dispatch(getPublicApiApprovalStatus());
  }, [dispatch]);

  useEffect(() => {
    if (status === Status.SUCCESS && isSuperAdminApproved === false) {
      showWarningNotification('Contact super admin for Flashcast Public API Access.');
      navigate('/integrations', { replace: true });
    }
  }, [status, isSuperAdminApproved, navigate, showWarningNotification]);

  useEffect(() => {
    if (!isSuperAdminApproved) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/swagger-ui-dist@5.0.0/swagger-ui.css';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://unpkg.com/swagger-ui-dist@5.0.0/swagger-ui-bundle.js';
    script.async = true;

    script.onload = () => {
      const selectedServer =
        env === 'PRODUCTION'
          ? swaggerData.servers.find((server) => server.description === 'PROD')
          : swaggerData.servers.find((server) => server.description === 'DEV');

      const dynamicSpec = {
        ...swaggerData,
        servers: selectedServer ? [selectedServer] : [],
      };

      (window as any).SwaggerUIBundle({
        spec: dynamicSpec,
        dom_id: '#swagger-ui-container',
      });
    };

    document.body.appendChild(script);

    return () => {
      const swaggerContainer = document.getElementById('swagger-ui-container');
      if (swaggerContainer) {
        swaggerContainer.innerHTML = '';
      }
      document.head.removeChild(link);
      document.body.removeChild(script);
    };
  }, [isSuperAdminApproved]);

  if (status === Status.PENDING || isSuperAdminApproved === null) {
    return null;
  }

  if (!isSuperAdminApproved) {
    return null;
  }

  return <div id="swagger-ui-container" className="swagger-ui-wrapper" />;
};

export default PublicApiDocs;